import { Injectable } from '@angular/core';
import * as filestack from 'filestack-js';
import { environment } from '../../../environments/environment';

export interface UploadResult {
  url: string;
  filename: string;
  mimetype: string;
  size: number;
}

export interface UploadOptions {
  path: string;           // appended to bucket base path e.g. "pages/abc123/"
  accept?: string[];
  maxFiles?: number;
  imageMax?: [number, number];  // [width, height] — resize before upload
  transformations?: any;        // filestack picker transformations config
}

@Injectable({ providedIn: 'root' })
export class UploadService {
  private client = filestack.init(environment.filestack.api);

  pick(options: UploadOptions): Promise<UploadResult[]> {
    const bucket = environment.filestack.bucket;

    return new Promise((resolve) => {
      this.client.picker({
        accept: options.accept || ['image/*'],
        maxFiles: options.maxFiles || 1,
        ...(options.imageMax ? { imageMax: options.imageMax } : {}),
        ...(options.transformations ? { transformations: options.transformations } : {}),
        storeTo: {
          ...bucket,
          path: bucket.path + options.path,
        },
        onUploadDone: (res) => {
          const results: UploadResult[] = res.filesUploaded.map((f: any) => ({
            url: f.url,
            filename: f.filename,
            mimetype: f.mimetype,
            size: f.size,
          }));
          resolve(results);
        },
        onCancel: () => resolve([]),
      }).open();
    });
  }
}
